import {
	connect
} from 'react-redux'
import GearSpecsComponent from '../components/GearSpecsComponent.jsx';
import {
	closeGearSpecModal
} from '../actions';

const mapStateToProps = (state) => ({
	showModal: state.getIn(['gearSpecReducer', 'showModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(closeGearSpecModal());
	},
})

const GearSpecsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(GearSpecsComponent)

export default GearSpecsContainer;


// WEBPACK FOOTER //
// ./src/containers/GearSpecsContainer.jsx